export default __webpack_public_path__ + "static/media/team.051c3743.svg";